import * as React from 'react';

function SvgPhone(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M20.06 21.84C8.07 19.36 3.04 9.12 2 4.27L7.48 2l2.9 5.32L7.11 9.2a21 21 0 007.72 7.65l1.85-3.22 5.32 2.9-1.94 5.32z"
      />
    </svg>
  );
}

export default SvgPhone;
